<div>
  <div
    class="splash-screen"
    [ngStyle]="{ opacity: opacityChange, transition: splashTransition, display: splashdisplay }">
    <img [attr.src]="loaderLogo" alt="Logo" />
    <span class="loader" role="status"></span>
  </div>
</div>
